import api from './api';

const systemSettingsService = {
  // -> { currency, currencySymbol, currencyPosition, updatedAt }
  getSettings: async () => (await api.get('/admin/system-settings')).data,

  // SUPER_ADMIN only. `currencySymbol` is derived server-side from the ISO code.
  updateSettings: async ({ currency, currencyPosition }) =>
    (await api.put('/admin/system-settings', { currency, currencyPosition })).data,
};

export default systemSettingsService;
